$.fn.megaMenu = function () {
  var $menu = $(this);
  var $window = $(window);
  var $submenu = $('.sub-menu', $menu);
  var $wrapper = $('#blackOut');
  // Megamenu Max Height
  function setMaxHeight(wHeight) {
    var maxH;
    if ($('.page-header').hasClass('variant-3')){
      maxH = $(window).height() - $('.page-header').outerHeight();
    } else maxH = $('body').hasClass('hdr-sticky') ? $(window).height() - $('.header-sticky').height() : $(window).height() - $('.page-header').height() - $('.page-header').offset().top;
    if (!$menu.hasClass('vertical')) {
      $submenu.each(function () {
        var el = $(this);
        el.find('.container').css({
          'max-height': maxH + 'px'
        });
      });
      //$('.slick-initialized', $menu).slick('setPosition');
    }
    if (!$menu.is(':visible')) {
      $('body').addClass('has-mobilemenu');
    } else {
      $('body').removeClass('has-mobilemenu');
    }
  }
  // check menu type
  function checkMenu() {
    if (!$menu.is(':visible')) {
      $('body').addClass('has-mobilemenu');
    } else {
      $('body').removeClass('has-mobilemenu');
    }
  }
  $.fn.hasScrollBar = function () {
    return this.get(0).scrollHeight > this.get(0).clientHeight;
  };
  if ($('body').hasClass('touch')) {
    $menu.on("click.megamenu", ".sub-menu a", function (e) {
      var $this = $(this);
      if (!$this.data('firstclick')) {
        $this.data('firstclick', true);
        e.preventDefault();
      }
    });
    $menu.on("click.megamenu", "li.mega-dropdown > a,li.simple-dropdown > a", function (e) {
      if (!$(this).parent('li').hasClass('hovered')) {
        setMaxHeight($(window).height());
        $submenu.find('.container').scrollTop(0);
        $('li', $menu).removeClass('hovered');
        $(this).parent('li').addClass('hovered');
        $menu.data('opened', true);
        if ($menu.hasClass('blackout') && $(this).next().length) {
          $wrapper.addClass('overlay');
        }
        e.preventDefault();
      } else {
        // second click go url
        $wrapper.removeClass('overlay');
        $(this).parent('li').removeClass('hovered');
        $menu.removeData('opened');
        $('.sub-menu a', $menu).removeData('firstclick');
      }
    });
    $menu.on("click.megamenu", function () {
      event.stopPropagation();
    });
    $wrapper.on('click', function () {
      if ($menu.data('opened')) {
        $('li', $menu).removeClass('hovered');
        $('.sub-menu a', $menu).removeData('firstclick');
        $wrapper.removeClass('overlay');
      }
    });
  } else {
    $menu.on("mouseenter", "li.mega-dropdown > a,li.simple-dropdown > a", function () {
      var $this = $(this);
      $submenu.find('.container').scrollLock();
      setMaxHeight($(window).height());
      $submenu.find('.container').scrollTop(0);
      $this.parent('li').addClass('hovered');
      if ($menu.hasClass('blackout') && $this.next().length) {
        $wrapper.addClass('overlay');
      }
    }).on("mouseleave", "li.mega-dropdown, li.simple-dropdown", function () {
      var $this = $(this);
      $this.closest('li').removeClass('noscroll');
      $wrapper.removeClass('overlay');
      $this.closest('li').removeClass('hovered');
    }).on("mouseleave", "li.mega-dropdown .sub-menu > .container", function () {
      var $this = $(this);
      $this.closest('li').removeClass('noscroll');
      $wrapper.removeClass('overlay');
      $this.closest('li').removeClass('hovered');
    });
  }
  // Dropdowns
  $('li', $menu).on('mouseenter', function (e) {
    var $this = $(this).addClass('hoverd');
    if ($('.sub-level', $this).length) {
      var $elm = $('.sub-level:first', this),
          windowW = $window.width(),
          windowH = $window.height(),
          menuItemPos = $this.position();
      if ($this.closest('.mega-dropdown').length) {
        if (!$('body').hasClass('rtl')) {
          $elm.css({
            top: menuItemPos.top,
            left: menuItemPos.left + Math.round($this.outerWidth())
          });
        } else {
          $elm.css({
            top: menuItemPos.top,
            left: menuItemPos.left - $elm.outerWidth()
          });
        }
      }
      var isXvisible = $('body').hasClass('rtl') ? $elm.offset().left >= 0 : $elm.offset().left + $elm.width() <= windowW;
      if (!isXvisible) {
        $this.addClass('to-right');
      } else {
        $this.removeClass('to-right');
      }
      var isYvisible = windowH + $window.scrollTop() - ($elm.offset().top + $elm.outerHeight());
      if (isYvisible < 0) {
        $elm.css({
          'margin-top': isYvisible + 'px'
        });
      }
    }
  }).on('mouseleave', function (e) {
    var $elm = $('.sub-level', this);
    var $this = $(this).removeClass('to-right').removeClass('hoverd');
    $elm.css({
      'margin-top': ''
    });
  });
  $(".category-links li", $menu).on('mouseenter', function (e) {
    if ($('ul', this).length) {
      var $elm = $('ul:first', this),
          windowW = $('body').width(),
          isEntirelyVisible = $elm.offset().left + $elm.width() <= windowW;
      if ($('body').hasClass('rtl')) {
        isEntirelyVisible = $elm.offset().left >= 0;
      }
      if (!isEntirelyVisible) {
        $(this).addClass('to-right');
      } else {
        setTimeout(function () {
          $(this).removeClass('to-right');
        }, 0);
      }
    }
  });
  // bottom header
  $(".toggleHeader").on('click', function (e) {
    $('.page-header').toggleClass('open');
    $(this).toggleClass('open');
    // disable menu links to prevent fast hover on it
    $menu.addClass('disable').delay(1000).queue(function () {
      $(this).removeClass('disable');
      $(this).dequeue();
    });
    e.preventDefault();
  })
  checkMenu();
  $(window).on('resize', function () {
    checkMenu();
  });
};